import { combineReducers } from '@reduxjs/toolkit'

import { adminConsole } from './slice/adminConsole'
import { AuthSlice } from './slice/AuthSlice'
import { createPlanReducer } from './slice/createPlanSlice'
import { dashboardDataReducer } from './slice/DashboardSlice'
import { divisionsAndRegionsSlice } from './slice/divisionsAndRegionsSlice'
import { drawerSlice } from './slice/drawerSlice'
import { exportedFilesSlice } from './slice/exportedExcelFilesSlice'
import { filteredPlansSlice } from './slice/filteredPlansSlice'
import { adminTemplateReducer } from './slice/GetAdminUploadTemplateSlice'
import { communityDataReducer } from './slice/GetCommunityNameSlice'
import { FavoritePlansSlice } from './slice/GetFavoritePlansSlice'
import { getHistorySlice } from './slice/getHistorySlice'
import { GetPlanSlice } from './slice/GetPlanSlice'
import { ReleaseNotesSlice } from './slice/GetReleaseNotesSlice'
import { modalSlice } from './slice/modalSlice'
import { multiFamilyPlanListingSlice } from './slice/MultiFamilyPlanListingSlice'
import { extractedPlans } from './slice/pendingPlansSlice'
import { planListingSlice } from './slice/planListingSlice'
import { plans } from './slice/plansSlice'
import { selectedPlansSlice } from './slice/selectedPlansSlice'
import { signalRSlice } from './slice/signalRSlice'
import { userUuidReducer } from './slice/userUuidSlice'
import { viewOnlyImageSlice } from './slice/viewOnlyImageSlice'

export const rootReducer = combineReducers({
  adminConsole: adminConsole.reducer,
  AdminUploadTemplate: adminTemplateReducer,
  Auth: AuthSlice.reducer,
  CommunityName: communityDataReducer,
  createPlan: createPlanReducer,
  Dashboard: dashboardDataReducer,
  divisionsAndRegions: divisionsAndRegionsSlice.reducer,
  drawer: drawerSlice.reducer,
  ExcelExportedFile: exportedFilesSlice.reducer,
  extractedPlans: extractedPlans.reducer,
  FavoritePlans: FavoritePlansSlice.reducer,
  filteredPlans: filteredPlansSlice.reducer,
  history: getHistorySlice.reducer,
  modalState: modalSlice.reducer,
  multiFamilyPlanListing: multiFamilyPlanListingSlice.reducer,
  Plan: GetPlanSlice.reducer,
  planListing: planListingSlice.reducer,
  plans: plans.reducer,
  ReleaseNotes: ReleaseNotesSlice.reducer,
  selectedPlans: selectedPlansSlice.reducer,
  signalR: signalRSlice.reducer,
  userUuid: userUuidReducer,
  viewOnlyImageSlice: viewOnlyImageSlice.reducer,
})
